export enum Locale {
  ES_ES = 'es-es',
  EN_US = 'en-us',
  EN_CA = 'en-ca',
}

export abstract class LocaleTimeUtils {
  private constructor() {}

  static readonly LOCALES_24H: ReadonlySet<string> = new Set([Locale.ES_ES]);

  // transforms `es_ES` into `es-es` for lookups
  static normalize(locale: string | undefined): string {
    return (locale ?? '').replace(/_/g, '-').toLowerCase();
  }

  static is24HourLocale(locale: string | undefined): boolean {
    return LocaleTimeUtils.LOCALES_24H.has(LocaleTimeUtils.normalize(locale));
  }

  static toIntlLocale(locale: string | undefined): string {
    return LocaleTimeUtils.normalize(locale) || Locale.EN_US;
  }

  static formatDate(value: Date, locale: string | undefined, options: Intl.DateTimeFormatOptions = {}): string {
    return new Intl.DateTimeFormat(LocaleTimeUtils.toIntlLocale(locale), {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      ...options,
    }).format(value);
  }

  static formatShortDate(value: Date, locale: string | undefined, options: Intl.DateTimeFormatOptions = {}): string {
    return new Intl.DateTimeFormat(LocaleTimeUtils.toIntlLocale(locale), {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      ...options,
    }).format(value);
  }

  static formatHourDate(value: Date, locale: string | undefined, options: Intl.DateTimeFormatOptions = {}): string {
    return new Intl.DateTimeFormat(LocaleTimeUtils.toIntlLocale(locale), {
      day: '2-digit',
      month: 'short',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      ...options,
    }).format(value);
  }

  // Compare two locales if they match
  static matchesLocale(input: string | undefined, target: Locale | string): boolean {
    return LocaleTimeUtils.normalize(input) === LocaleTimeUtils.normalize(target);
  }
}
